import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
// import 'react-lazy-load-image-component/src/effects/blur.css';
import { Link } from 'react-router-dom';

import styles from '../../App.module.css'

import noThumb from "../../images/no-thumb.jpg";

function ImageBox(image) {
    let thumb = null;
    if(image.thumb.includes('storage/media/')) {
        thumb = `${process.env.REACT_APP_API_URL}/${image.thumb}`;
    }else {
        thumb = image.thumb;
    }
    
    return (
        <div className={styles.image}>
            <Link to={`/image/${image.id}/${image.nice_url || image.title.toLowerCase().replace(/[^A-Z0-9]+/ig, "-")}`}>
                <LazyLoadImage
                    alt={image.title}
                    src={thumb}
                    effect="blur"
                    onError={e => {e.target.src = noThumb}}
                />
            </Link>
        </div>
    )
}

export default ImageBox